// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner--spinner--69e24d","darkStroke":"Spinner--darkStroke--6d3b14"};